import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "./Modal";
import { TextAreaField } from "../../fields/base/TextAreaField";
import { Button } from "./Button";
import { VStack, Wrap } from "../../../../styled-system/jsx";

interface BulkEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (values: string[]) => void;
  title?: string;
  defaultValues?: string[];
  parseSeparators?: RegExp;
}

const BulkEditModal = ({
  isOpen,
  onClose,
  onSave,
  title,
  defaultValues = [],
  parseSeparators = /[\n,]/,
}: BulkEditModalProps) => {
  const { t } = useTranslation(["common"]);
  const [text, setText] = useState(() => defaultValues.join("\n"));

  useEffect(() => {
    if (isOpen) {
      setText(defaultValues.join("\n"));
    }
  }, [isOpen, defaultValues]);

  const handleSave = () => {
    const values = text
      .split(parseSeparators)
      .map((s) => s.trim())
      .filter(Boolean);

    onSave(values);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      title={title}
      css={{
        width: "50vw",
      }}
    >
      <VStack alignItems={"stretch"} paddingX={"xlarge"} paddingTop={"xlarge"}>
        <TextAreaField aria-label={t(($) => $.common.bulkEdit["Bulk input"])} value={text} onChange={setText} />
        <span>{t(($) => $.common.bulkEdit["Separate text using commas or new lines"])}</span>
        <Wrap justify={"space-evenly"}>
          <Button variant={"secondary"} onPress={onClose}>
            {t(($) => $.common.actions.Cancel)}
          </Button>
          <Button onPress={handleSave}>{t(($) => $.common.actions.Save)}</Button>
        </Wrap>
      </VStack>
    </Modal>
  );
};

export default BulkEditModal;
